var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "card-container",
          staticStyle: { margin: "15px 0 20px 0" },
          attrs: { shadow: "hover" }
        },
        [
          _vm.opcoesAcoes
            ? _c("app-opcoes-header-analise", {
                staticClass: "right",
                attrs: {
                  idProcesso: _vm.idProcesso,
                  protocolo: _vm.numeroProtocolo,
                  statusProcesso: _vm.statusProcesso,
                  numeroProcesso: _vm.numeroProcesso,
                  tipoProcesso: _vm.tipoCodigoProcesso,
                  btnNotificarInteressado: false,
                  btnRetificacao: false,
                  btnSolicitarInformacao: false
                }
              })
            : _vm._e(),
          _c("h4", [
            _vm._v("Nome do Interessado:"),
            _c("span", { staticClass: "span-style" }, [
              _vm._v(
                " " + _vm._s(_vm.nomeInteressado ? _vm.nomeInteressado : " - ")
              )
            ])
          ]),
          _c("h4", [
            _vm._v("CPF/CNPJ do Interessado:"),
            _c("span", { staticClass: "span-style" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.cpfCnpjInteressado ? _vm.cpfCnpjInteressado : " - "
                  )
              )
            ])
          ]),
          _c("h4", [
            _vm._v("Setor:"),
            _c("span", { staticClass: "span-style" }, [
              _vm._v(
                " " + _vm._s(_vm.setorProcesso ? _vm.setorProcesso : " - ")
              )
            ])
          ]),
          _c("h4", [
            _vm._v("Status:"),
            _c("span", { staticClass: "span-style" }, [
              _vm._v(
                " " + _vm._s(_vm.statusProcesso ? _vm.statusProcesso : " - ")
              )
            ])
          ]),
          _vm.usuario
            ? _c("h4", [
                _vm._v("Usuario:"),
                _c("span", { staticClass: "span-style" }, [
                  _vm._v(
                    _vm._s(
                      _vm.usuario.pessoa.nomeRazaoSocial
                        ? _vm.usuario.pessoa.nomeRazaoSocial
                        : " - "
                    )
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6ef7c6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6ef7c6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/components/CardProcesso.vue
// module id = null
// module chunks = 